import React from 'react';
import LandingPage from './landing/LandingPage';

function App() {
	return <LandingPage />;
}

export default App;
